'use client';

import * as DS from '@aurorasolar/ds';
import { x } from '@xstyled/styled-components';
import { CSSProperties, useEffect, useState, type ReactNode } from 'react';

type Props = { children: ReactNode } & DS.IText;

export const TruncateText = ({ children, ...textProps }: Props) => {
  const [screenSize, setScreenSize] = useState<string | number | symbol>('md');
  const breakpoint = DS.useBreakpoint();

  useEffect(() => {
    setScreenSize(breakpoint);
  }, [breakpoint]);

  return (
    <x.div
      display="-webkit-box"
      flexShrink={1}
      mb={{ md: 4 }}
      overflow="hidden"
      style={{ WebkitBoxOrient: 'vertical', WebkitLineClamp: screenSize === 'sm' ? 2 : 6 } as CSSProperties}
      textOverflow="ellipsis"
      whiteSpace="normal"
      {...textProps}
    >
      {children}
    </x.div>
  );
};
